import { EmrNotificationApiDto } from "@/model/Patient"
import EMRNotificationCell from "@/pages/patient-readings/EMRNotificationCell"
import {
  generateMonthDates,
  groupNotificationsByDate,
} from "@/utils/calendar-utils"
import cn from "@/utils/cn"

type EMRNotificationsCalendarProps = {
  notifications: EmrNotificationApiDto[]
  clinicTimeZone: string
  selectedMonth: { year: number; month: number }
  highlightedCellDate: string | null
  onNavigateToRow: (notificationId: string) => void
}

const EMRNotificationsCalendar = ({
  notifications,
  clinicTimeZone,
  selectedMonth,
  highlightedCellDate,
  onNavigateToRow,
}: EMRNotificationsCalendarProps) => {
  const { year, month } = selectedMonth
  const dates = generateMonthDates(year, month)

  const notificationsByDate = groupNotificationsByDate(
    notifications,
    clinicTimeZone
  )

  return (
    <div id="emr-notifications-calendar" className="w-full">
      <div className="grid grid-cols-7 gap-2">
        <WeekdayHeaderCell>Sun</WeekdayHeaderCell>
        <WeekdayHeaderCell>Mon</WeekdayHeaderCell>
        <WeekdayHeaderCell>Tue</WeekdayHeaderCell>
        <WeekdayHeaderCell>Wed</WeekdayHeaderCell>
        <WeekdayHeaderCell>Thu</WeekdayHeaderCell>
        <WeekdayHeaderCell>Fri</WeekdayHeaderCell>
        <WeekdayHeaderCell>Sat</WeekdayHeaderCell>

        {dates.map((date) => {
          const dateKey = date.toString()
          const cellNotifications = notificationsByDate.get(dateKey) || []
          const isHighlighted = highlightedCellDate === dateKey
          const isOutsideMonth =
            date.monthValue() !== month || date.year() !== year

          return (
            <EMRNotificationCell
              key={dateKey}
              date={date}
              notifications={cellNotifications}
              clinicTimeZone={clinicTimeZone}
              isHighlighted={isHighlighted}
              isOutsideMonth={isOutsideMonth}
              onNavigateToRow={onNavigateToRow}
            />
          )
        })}
      </div>
    </div>
  )
}

const WeekdayHeaderCell = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => (
  <div
    className={cn(
      "flex items-center justify-end p-2 text-sm font-semibold text-primary/90",
      className
    )}
  >
    {children}
  </div>
)

export default EMRNotificationsCalendar
